import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useState } from "react";
import { Radio, Tabs } from "antd";
import LeftMenuGroup from "./LeftMenuGroup";
import Search from "../../atoms/Search";
import AlertMessage from '../AlertMessage';
import { isEmpty } from "../../utils/helper";
import './style.scss';
const LeftNavMenu = props => {
  const [view, setView] = useState('list');
  const [searchText, setsearchText] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const {
    allCards,
    menuItems
  } = props;
  const [activeTab, setActiveTab] = useState('apps');
  const filteredSearch = searchText ? allCards.filter(val => val.label.toLowerCase().includes(searchText.toLowerCase()) || val.slabel.toLowerCase().includes(searchText.toLowerCase())) : allCards;
  const activeTabInfo = useMemo(() => menuItems.find(value => value.key === activeTab), [menuItems, activeTab]);
  ;
  const handleTabChange = key => {
    setActiveTab(key);
  };
  const handleOnChange = event => {
    setsearchText(event.target.value);
    if (event.target.value) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
  };
  const handleOnClick = () => {
    setIsSearching(false);
    setsearchText('');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leftnav-menu-container"
  }, /*#__PURE__*/React.createElement(Search, {
    handleOnChange: handleOnChange,
    searchText: searchText,
    isSearching: isSearching,
    handleOnClick: handleOnClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "leftnavmenu-menu-container"
  }, !searchText && /*#__PURE__*/React.createElement("div", {
    className: "leftnavmenu-menu-controls"
  }, /*#__PURE__*/React.createElement(Tabs, {
    type: "card",
    onChange: handleTabChange,
    activeKey: activeTab
  }, menuItems.map(groupType => groupType.groups.length > 0 && /*#__PURE__*/React.createElement(Tabs.TabPane, {
    tab: /*#__PURE__*/React.createElement("h4", {
      className: "leftnavmenu-tab"
    }, /*#__PURE__*/React.createElement("span", {
      className: groupType.icon
    }), " ", "".concat(groupType.name)),
    key: groupType.key
  }))), /*#__PURE__*/React.createElement(Radio.Group, {
    value: view,
    onChange: e => setView(e.target.value)
  }, /*#__PURE__*/React.createElement(Radio.Button, {
    value: "list"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-list-view"
  })), /*#__PURE__*/React.createElement(Radio.Button, {
    value: "grid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-thumbnail-view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "leftnavmenu-group-container"
  }, searchText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LeftMenuGroup, _extends({
    cardItems: filteredSearch,
    isLastItem: true,
    view: "searchView"
  }, props)), isEmpty(filteredSearch) && /*#__PURE__*/React.createElement(AlertMessage, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, activeTabInfo && !isEmpty(activeTabInfo.groups) ? activeTabInfo.groups.map(group => /*#__PURE__*/React.createElement(LeftMenuGroup, _extends({
    cardItems: group.cards,
    view: view,
    key: group.name,
    title: group.name,
    icon: group.iconName,
    iconColor: group.colorCode
  }, props))) : /*#__PURE__*/React.createElement(AlertMessage, null)))));
};
LeftNavMenu.propTypes = {};
export default LeftNavMenu;